import {ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal} from "@angular/core";
import {IconButtonType} from "./icon-button";
import {NgClass} from '@angular/common';
import {IconComponent} from "../../ui-elements/icon/icon.component";
import {CssVarDirective} from '../../utils/css-var.directive';
import {TouchableDirective} from '../../ui-elements/touchable.directive';
import {ActivatableDirective} from '../../ui-elements/activatable.directive';

@Component({
    selector: "woa-icon-button",
    templateUrl: "./icon-button.component.html",
    styleUrl: "./icon-button.component.scss",
    host: {
        "[attr.type]": "type()",
        "[class.disabled]": "disabled()",
        "[class.unavailable]": "unavailable()"
    },
    imports: [
        CssVarDirective,
        IconComponent,
        NgClass,
        TouchableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconButtonComponent extends ActivatableDirective {
    public readonly type: InputSignal<IconButtonType> = input.required<IconButtonType>();

    public readonly icon: InputSignal<string> = input<string>();
    public readonly disabled: InputSignal<boolean> = input<boolean>(false);
    public readonly unavailable: InputSignal<boolean> = input<boolean>(false);
    public readonly circular: InputSignal<boolean> = input<boolean>(false);
    public readonly enlarged: InputSignal<boolean> = input<boolean>(false);

    public readonly iconName: Signal<string> = computed<string>(() => {
        if (this.icon()) {
            return this.icon();
        }
        switch (this.type()) {
            case IconButtonType.BACK:
                return "arrow-left";
            case IconButtonType.FORWARD:
                return "arrow-right";
            case IconButtonType.LEFT:
                return "angle-left";
            case IconButtonType.RIGHT:
                return "angle-right";
            case IconButtonType.CLOSE:
                return "cross";
            case IconButtonType.TOP:
                return "angle-double-small-up";
            case IconButtonType.REFRESH:
                return "rotate-right";
            case IconButtonType.MENU:
                return "menu-burger";
            case IconButtonType.SETTINGS:
                return "settings";
            case IconButtonType.INCREMENT:
                return "plus";
            case IconButtonType.DECREMENT:
                return "minus";
            case IconButtonType.REMOVE:
                return "trash";
            case IconButtonType.SHOW:
                return "eye";
            case IconButtonType.HIDE:
                return "eye-crossed";
            case IconButtonType.SCAN:
                return "qrcode";
            case IconButtonType.SEARCH:
                return "search";
            default:
                return undefined;
        }
    });

    public readonly defaultIconSize: Signal<number> = computed<number>(() => {
        switch (this.type()) {
            case IconButtonType.CLOSE:
                return 21;
            case IconButtonType.REFRESH:
                return 21;
            case IconButtonType.INCREMENT:
                return 12;
            case IconButtonType.DECREMENT:
                return 12;
            case IconButtonType.REMOVE:
                return 18;
            case IconButtonType.SEARCH:
                return 21;
            default:
                return 25;
        }
    });
}
